import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CloudContext = createContext(null);

export function CloudProvider({ children }) {
  const [state, setState] = useState({ status: "Connected", mode: "cloud", label: "CLOUD CONNECTED" });

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${base}/system/status`);
      setState(r.data);
    } catch {
      /* keep last known state on transient network errors */
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);

  return <CloudContext.Provider value={{ state, refresh }}>{children}</CloudContext.Provider>;
}

export const useCloud = () => useContext(CloudContext);
